'use strict';

var React = require('react');
var createReactClass = require('create-react-class');
var LocalizationMixin = require("../../localization/CommonLocalizationMixin");

module.exports = createReactClass({
    displayName: 'exports',

    mixins: [LocalizationMixin],
    render: function render() {
        var img_1 = "";
        var img_2 = "";
        var verification_step_local = "";
        var verification_row_local = "";

        if (this.props.lang) {
            switch (this.props.lang) {
                case 'en':
                    img_1 = "/images/common/img_email_verification_1_en.png";
                    img_2 = "/images/common/img_email_verification_2_en.png";
                    verification_step_local = "verification-step-en";
                    verification_row_local = "verification-row-en";
                    break;
                case 'es':
                    img_1 = "/images/common/img_email_verification_1_es.png";
                    img_2 = "/images/common/img_email_verification_2_es.png";
                    verification_step_local = "verification-step-es";
                    verification_row_local = "verification-row-es";
                    break;
                case 'fr':
                    img_1 = "/images/common/img_email_verification_1_fr.png";
                    img_2 = "/images/common/img_email_verification_2_fr.png";
                    verification_step_local = "verification-step-fr";
                    verification_row_local = "verification-row-fr";
                    break;
                default:
                    img_1 = "/images/common/img_email_verification_1_en.png";
                    img_2 = "/images/common/img_email_verification_2_en.png";
                    verification_step_local = "verification-step-en";
                    verification_row_local = "verification-row-en";
            }
        }

        var verification_step = 'verification-step ' + verification_step_local;
        var verification_row = 'verification-row ' + verification_row_local;

        return React.createElement(
            'div',
            { className: 'container', role: 'main' },
            React.createElement(
                'div',
                { className: 'row' },
                React.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-12 col-md-12' },
                    React.createElement(
                        'h1',
                        { className: 'verification-title' },
                        this.getLocalizedText('email_verification_title')
                    )
                )
            ),
            React.createElement(
                'div',
                { className: 'verification-block verification-block-left' },
                React.createElement(
                    'div',
                    { className: verification_row },
                    React.createElement(
                        'div',
                        { className: verification_step },
                        React.createElement(
                            'div',
                            null,
                            '1'
                        )
                    ),
                    React.createElement(
                        'div',
                        { className: 'verification-up' },
                        React.createElement('img', { src: img_1, alt: '', role: 'presentation' })
                    ),
                    React.createElement(
                        'div',
                        { className: 'verification-down' },
                        React.createElement(
                            'p',
                            null,
                            this.getLocalizedText('email_verification_step1_title_1'),
                            React.createElement(
                                'strong',
                                null,
                                ' ',
                                this.getLocalizedText('email_verification_step1_title_2'),
                                ' '
                            ),
                            this.getLocalizedText('email_verification_step1_title_3')
                        )
                    )
                )
            ),
            React.createElement(
                'div',
                { className: 'verification-block verification-block-right' },
                React.createElement(
                    'div',
                    { className: verification_row },
                    React.createElement(
                        'div',
                        { className: verification_step },
                        React.createElement(
                            'div',
                            null,
                            '2'
                        )
                    ),
                    React.createElement(
                        'div',
                        { className: 'verification-up' },
                        React.createElement('img', { src: img_2, alt: '', role: 'presentation' })
                    ),
                    React.createElement(
                        'div',
                        { className: 'verification-down' },
                        React.createElement(
                            'p',
                            null,
                            this.getLocalizedText('email_verification_step2_title_1'),
                            React.createElement(
                                'strong',
                                null,
                                ' ',
                                this.getLocalizedText('email_verification_step2_title_2'),
                                ' '
                            ),
                            this.getLocalizedText('email_verification_step2_title_3')
                        )
                    )
                )
            )
        );
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/loginComponents/verification.js
// module id = 606
// module chunks = 0